import _isString from 'lodash/isString';

function isStringOrNumberArray(key: unknown): key is string | number | (string | number)[] {
  return Array.isArray(key) && key.every((item) => _isString(item) || typeof item === 'number');
}

export const validateStorageKey = (
  key: unknown,
  operation: string,
): key is string | number | (string | number)[] => {
  if (!key || (!_isString(key) && !isStringOrNumberArray(key))) {
    throw new Error(
      `Key is required and must be a string or array of strings and numbers for ${operation} operation`,
    );
  }
  return true;
};

export const validateStorageValue = (value: unknown): void => {
  if (
    value !== null &&
    value !== undefined &&
    typeof value !== 'string' &&
    typeof value !== 'number' &&
    typeof value !== 'boolean' &&
    !Array.isArray(value) &&
    typeof value !== 'object'
  ) {
    throw new Error('Value must be a valid JSON serializable type');
  }
};
